import React from "react";
import { Route, Switch, useParams } from "react-router-dom";
import AdminRoute from "./components/AdminRoute";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";

import Home from "./containers/Home";
import NotFound from "./containers/NotFound";
import Login from "./containers/Login";
import Profil from "./containers/Profil";
import Anmodning from "./containers/Anmodning";
import Setup from "./containers/Setup";
import Documents from "./containers/Documents";
import Monitor from "./containers/Monitor";
import InteresseOmraader from "./containers/InteresseOmraader";
import Users from "./containers/Users";



export default function Routes({ appProps }) {
  return (
    <Switch>
      { /* Make only public route login, rest requires auth */ }
      <AuthenticatedRoute path="/" exact component={Home} appProps={appProps} />
      <UnauthenticatedRoute path="/login" exact component={Login} appProps={appProps} />

      { /* Add vendor-available routes */ }
      <AuthenticatedRoute path="/anmodning/:id" exact component={Anmodning} appProps={appProps} />
      <AuthenticatedRoute path="/profil/" exact component={Profil} appProps={appProps} />
      <AuthenticatedRoute path="/dokumenter/" exact component={Documents} appProps={appProps} />
      <AuthenticatedRoute path="/interesseomraade/" exact component={InteresseOmraader} appProps={appProps} />
      
      { /* Add admin-only routes */ }
      <AdminRoute path="/setup/" exact component={Setup} appProps={appProps} />   
      <AdminRoute path="/monitor/" exact component={Monitor} appProps={appProps} />   
      <AdminRoute path="/users/" exact component={Users} appProps={appProps} />   

      { /* Finally, catch all unmatched routes */ }
      <Route component={NotFound} />
    </Switch>
  );
}

